import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { TermsAndConditions } from '../Components/Organisms/TermsAndConditions/TermsAndConditions'
import { CommonFormContextProvider } from '../../React/Common/Contexts/CommonFormContext'
import { useDisableUserInfoErrors } from '../../React/Common/Hooks/useDisableUserInfoErrors'

@Route(RouteID.TERMS_AND_CONDITIONS)
export class TermsAndConditionsPage extends Component {
    render(): ReactElement {
        useDisableUserInfoErrors()

        return (
            <RouteGuard route={RouteID.TERMS_AND_CONDITIONS}>
                <CommonFormContextProvider>
                    <TermsAndConditions />
                </CommonFormContextProvider>
            </RouteGuard>
        )
    }
}
